// extracted by mini-css-extract-plugin
export default {"export":"styles_export__CIo8k","pageTitle":"styles_pageTitle__EvkYv","contentWrap":"styles_contentWrap__92goV","icon":"styles_icon__AC74D","content":"styles_content__YxzPa"};